import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { permitStatusClass, permitStatusLabel } from './permit-status';

/** Shared status pill used across the queue, CRM detail and public views. */
@Component({
    selector: 'app-permit-status-badge',
    template: `<span class="badge rounded-pill {{ cls }} text-capitalize">{{ label }}</span>`,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class PermitStatusBadgeComponent {
    @Input() status = '';
    /**
     * Issued but not yet in force, from the permit's `upcoming` field.
     *
     * Passed in rather than worked out here: it is a comparison against today in the
     * Northern Territory, and the browser's today is not always the same day.
     */
    @Input() upcoming = false;

    public get label(): string {
        return permitStatusLabel(this.status, this.upcoming);
    }

    /** Shared with the permits list so a status looks the same wherever it appears. */
    public get cls(): string {
        return permitStatusClass(this.status, this.upcoming);
    }
}
